import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { DashboardData } from '../../../services/dashboard.service';

@Component({
  selector: 'app-dash-kpi-rate',
  templateUrl: './dash-kpi-rate.widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
  styles: [':host { display: block; height: 100%; }']
})
export class DashKpiRateWidgetComponent {
  data = input<DashboardData | null>(null);
}
